import { useTranslation } from 'react-i18next';
import { ArticleLink } from '../ArticleLink';
import type { IArticle } from './data';
import { useDismissArticleTip } from './useDismissArticleTip';

interface DismissableArticleProps {
  article: IArticle;
  id: string;
  tipIndex: number;
  onClick: (id: string) => void;
}

export const DismissableArticle = ({
  article: { articleKey, ...article },
  id,
  tipIndex,
  onClick,
}: DismissableArticleProps): JSX.Element => {
  const { t } = useTranslation();
  const { dismiss } = useDismissArticleTip(id);

  const handleArticleClick = () => {
    onClick(id);
    dismiss();
  };

  return (
    <ArticleLink
      onClick={() => handleArticleClick()}
      key={id}
      href={article.link}
      wrapperLabel={t(`activation:space-overview.for-you.hotjar-tips.${articleKey}.title`)}
      caption={t(`activation:space-overview.for-you.hotjar-tips.${articleKey}.caption`)}
      title={t(`activation:space-overview.for-you.hotjar-tips.${articleKey}.title`)}
      imageUrl={article.image}
      target="_blank"
      expanded={tipIndex === 0}
    />
  );
};
